import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  showArrow?: boolean;
}
export function CTAButton({
  children,
  className = '',
  showArrow = true
}: CTAButtonProps) {
  return <motion.a href="https://tumomentovital.com/cart/47598816723136:1" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('offer-cta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }} className={`
        inline-flex items-center justify-center gap-3
        px-8 py-4 md:px-10 md:py-5
        bg-[#d4a853] hover:bg-[#f5c542]
        text-[#0f172a] font-bold text-lg md:text-xl
        rounded-full
        cta-pulse
        transition-colors duration-300
        cursor-pointer
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-1">
      {children}
      {showArrow && <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-2" />}
    </motion.a>;
}